import moment from 'moment'

export interface Age {
  days: number
  months: number
  years: number
}

export function calculateAge(birthDate: string | number, refDate: string | number = Date.now()): Age {
  const ref = moment(refDate)
  const birth = moment(birthDate)

  const duration = moment.duration(ref.diff(birth))

  return {
    years: duration.years(),
    months: duration.months(),
    days: duration.days(),
  }
}
